import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { LoadingOutlined } from "@ant-design/icons"

//------------------------------------------------------------------------------

function AppButton(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { children, onClick, htmlType, uxType, loading, icon } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function getThemeClassName() {
        switch (uxType) {
            case "warning": {
                return "warning"
            }
            case "success": {
                return "success"
            }

            case "secondary": {
                return "secondary"
            }
            case "tertiary": {
                return "tertiary"
            }

            case "link": {
                return "link"
            }

            case "delete": {
                return "delete"
            }

            default: {
                return ""
            }
        }
    }
    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <button
            className={`${props.className} ${getThemeClassName()}`}
            type={htmlType}
            onClick={!loading && onClick}
        >
            {loading && <LoadingOutlined className="loader" />}
            {children}
            {icon && <div className="icon center">{icon}</div>}
        </button>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppButton.propTypes = {
    className: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    type: PropTypes.string,
    uxType: PropTypes.string,
    htmlType: PropTypes.string,
    loading: PropTypes.bool,
    icon: PropTypes.element,
}

AppButton.defaultProps = {
    onClick: () => {},
    htmlType: "submit",
    style: "default",
}

// ----------------------------------------------------------------------------

const StyledAppButton = styled(AppButton)`
    & {
        position: relative;

        padding: 0 24px;
        max-width: 300px;
        height: 48px;
        border: 1px solid ${(props) => props.theme.colors.primary};
        border-radius: 6px;
        background-color: ${(props) => props.theme.colors.primary};

        font-weight: 600;
        color: ${(props) => props.theme.colors.light} !important;

        cursor: pointer;
        outline: none;
        transition: all 0.2s ease-in-out;

        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        * > {
            z-index: 3;
        }

        .loader {
            margin-right: 5px;
        }

        .icon {
            margin-left: 15px;
        }

        :hover {
            ::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                background-color: ${(props) =>
                    `${props.theme.colors.hoverActiveClearer}`};

                z-index: 2;
            }
        }
    }

    &.secondary {
        border: 2px solid ${(props) => props.theme.colors.primary};
        background-color: ${(props) => props.theme.colors.light};
        color: ${(props) => props.theme.colors.primary} !important;

        :hover {
            ::before {
                background-color: ${(props) =>
                    props.theme.colors.hoverTransparency};
            }
        }
    }

    &.tertiary {
        border: 2px solid ${(props) => props.theme.colors.dark100};
        background-color: ${(props) => props.theme.colors.dark100};
        color: ${(props) => props.theme.colors.dark600} !important;

        :hover {
            ::before {
                background-color: ${(props) =>
                    props.theme.colors.hoverTransparency};
            }
        }
    }

    &.success {
        border: 1px solid ${(props) => props.theme.colors.successColor};
        background-color: transparent;
        color: ${(props) => props.theme.colors.successColor} !important;

        :hover {
        }
    }

    &.link {
        padding: 0 12px;
        border: none;
        background-color: transparent;
        color: ${(props) => props.theme.colors.primaryColor} !important;
        font-weight: 500;

        :hover {
        }
    }

    &.warning {
        border: 1px solid ${(props) => props.theme.colors.warningDarkColor};
        background-color: transparent;
        color: ${(props) => props.theme.colors.warningDarkColor} !important;

        :hover {
            border-color: ${(props) => props.theme.colors.warningLightColor};
            color: ${(props) =>
                props.theme.colors.warningLightColor} !important;
        }
    }

    &.delete {
        border: 2px solid ${(props) => props.theme.colors.error};
        background-color: transparent;
        color: ${(props) => props.theme.colors.error} !important;
    }
`
// ----------------------------------------------------------------------------

export default StyledAppButton
